import { MetaType, QtiInteractionType, Feedback, TTS } from "../types"
import {
  actionCreatorGuard,
  getArrayTypeReducerGuard,
  processActionMeta,
  reducerGuard
} from "../reducers"
import { QtiInteractions } from "../../authoring/pages/QtiAuthoring/helpers/types"

import { ResponseDeclaration } from "../../authoring/pages/QtiAuthoring/helpers/types"

const kind = "block_qti_interactions"

export type BlockQtiInteraction = {
  kind: typeof kind
  version: number
  type: QtiInteractionType
  content: QtiInteractions
  tts: TTS
  choicesTTS: Array<TTS>
  meta: MetaType
  responseDeclaration: ResponseDeclaration[]
  answerFeedbacks: Feedback[]
  generalFeedbacks: Array<Feedback>
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockQtiInteraction, MetaType>("meta", kind),
  type: actionCreatorGuard<BlockQtiInteraction, QtiInteractionType>(
    "type",
    kind
  ),
  content: actionCreatorGuard<BlockQtiInteraction, any>("content", kind),
  tts: actionCreatorGuard<BlockQtiInteraction, TTS>("tts", kind),
  choicesTTS: actionCreatorGuard<BlockQtiInteraction, Array<TTS>>(
    "choicesTTS",
    kind
  ),
  responseDeclaration: actionCreatorGuard<
    BlockQtiInteraction,
    Array<ResponseDeclaration>
  >("responseDeclaration", kind),
  answerFeedbacks: actionCreatorGuard<BlockQtiInteraction, Array<Feedback>>(
    "answerFeedbacks",
    kind
  ),
  generalFeedbacks: actionCreatorGuard<BlockQtiInteraction, Array<Feedback>>(
    "generalFeedbacks",
    kind
  )
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockQtiInteraction,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockQtiInteractionAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

// Our exported reducer
export const blockQtiInteractionReducer = reducerGuard<BlockQtiInteraction>(
  kind
)
  .case(...reducerAction.meta)
  .case(...reducerAction.type)
  .case(...reducerAction.content)
  .case(...reducerAction.tts)
  .case(...reducerAction.choicesTTS)
  .case(...reducerAction.responseDeclaration)
  .case(...reducerAction.answerFeedbacks)
  .case(...reducerAction.generalFeedbacks)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "answerFeedbacks":
        return getArrayTypeReducerGuard<BlockQtiInteraction, Feedback>(
          kind,
          "answerFeedbacks",
          "Feedback",
          prevState,
          action
        )
      case "generalFeedbacks":
        return getArrayTypeReducerGuard<BlockQtiInteraction, Feedback>(
          "block_qti_interactions",
          "generalFeedbacks",
          "Feedback",
          prevState,
          action
        )
      case "choicesTTS":
        return getArrayTypeReducerGuard<BlockQtiInteraction, TTS>(
          "block_qti_interactions",
          "choicesTTS",
          "TTS",
          prevState,
          action
        )
    }
    return prevState
  })
// .build()
